/**
 * Created by olga on 04.08.2025
 */
const HomefixIntroAnimation = {};

HomefixIntroAnimation.show = function (callback) {
    const doorUnit = Map2d.currentMap.listAvailableUnits({ code: "garbage1", stage: 0 })[0];

    if (!doorUnit || cleverapps.user.currentPhysicalLevel.level !== 0 || cleverapps.user.currentPhysicalLevel.episode !== 0) {
        callback();
        return;
    }

    const scene = cleverapps.Scenes.GetRunningScene();
    if (scene.startMusicAction && !scene.startMusicAction.isDone()) {
        scene.stopAction(scene.startMusicAction);
        delete scene.startMusicAction;
    }

    cleverapps.effects.fire("location.homefix.intro.music");

    cleverapps.focusManager.compound(callback, [
        function (f) {
            HomefixIntroAnimation.taxiAnimation();
            cleverapps.timeouts.setTimeout(f, 6000);
        },

        function (f) {
            if (!doorUnit.onGetView()) {
                Map2d.currentMap.onAddUnit(doorUnit.x, doorUnit.y, doorUnit);
            }
            doorUnit.onGetView().sprite.setAnimation(0, "start", false);
            doorUnit.hideAdditionalViews();

            Map2dScroller.currentScroller.zoomIn(doorUnit, {
                zoom: 1.7,
                duration: 1.5
            });
            cleverapps.timeouts.setTimeout(f, 700);
        },

        function (f) {
            HomefixIntroAnimation.addUnitAnimation(HomefixIntroAnimation.HERO_POSITIONS[1], "knock");
            cleverapps.timeouts.setTimeout(() => {
                doorUnit.onGetView().sprite.setAnimationAndIdleAfter("fall", "idle");
                cleverapps.effects.fire("location.homefix.intro.door");
                doorUnit.onGetView().sprite.setCompleteListener(f);
                doorUnit.onGetView().sprite.setSafeToRemove();
            }, 1500);
        },
        function (f) {
            cleverapps.effects.fire("location.homefix.intro.woman2");
            doorUnit.showAdditionalViews();
            cleverapps.timeouts.setTimeout(f, 500);
            scene.sceneComponent.startOrRestartMusic({
                res: cleverapps.styles.SceneComponent.sound.res
            });
        }
    ]);
};

HomefixIntroAnimation.taxiAnimation = function () {
    const mapView = Map2d.currentMap.getMapView();
    const taxiAnimation = new cleverapps.Spine(bundles.homefix.jsons.taxi_json);

    const firstPositionInGrid = HomefixIntroAnimation.TAXI_POSITIONS[0];
    const firstPosition = mapView.alignInGrid(firstPositionInGrid.x, firstPositionInGrid.y);
    const secondPositionInGrid = HomefixIntroAnimation.TAXI_POSITIONS[1];
    const secondPosition = mapView.alignInGrid(secondPositionInGrid.x, secondPositionInGrid.y);
    const thirdPositionInGrid = HomefixIntroAnimation.TAXI_POSITIONS[2];
    const thirdPosition = mapView.alignInGrid(thirdPositionInGrid.x, thirdPositionInGrid.y);

    mapView.animations.addChild(taxiAnimation, 1);
    taxiAnimation.setAlignment(firstPosition);
    taxiAnimation.setAnimation(0, "drive", false);
    taxiAnimation.setCompleteListenerRemove();

    Map2dScroller.currentScroller.zoomIn(firstPositionInGrid, {
        zoom: 1.7,
        duration: 0
    });

    taxiAnimation.runAction(
        new cc.Sequence(
            new cc.CallFunc(
                () => {
                    cleverapps.effects.fire("location.homefix.intro.car");
                    Map2dScroller.currentScroller.zoomIn(secondPositionInGrid, {
                        zoom: 1.7,
                        duration: 1.67
                    });
                }
            ),

            new cc.MoveTo(1.67, secondPosition).easing(cc.easeInOut(2)),
            new cc.CallFunc(() => {
                HomefixIntroAnimation.addUnitAnimation(HomefixIntroAnimation.HERO_POSITIONS[0], "greetings");
                cleverapps.timeouts.setTimeout(() => {
                    cleverapps.effects.fire("location.homefix.intro.woman1");
                }, 1700);
            }),

            new cc.DelayTime(2.33),
            new cc.MoveTo(2.33, thirdPosition).easing(cc.easeIn(2))
        )
    );
};

HomefixIntroAnimation.addUnitAnimation = function (position, animationName) {
    const mapView = Map2d.currentMap.getMapView();
    const unitImage = UnitView.getUnitImage(HomefixIntroAnimation.HERO_UNIT);
    unitImage.setAnimation(0, animationName, false);
    mapView.animations.addChild(unitImage);
    unitImage.setAlignment(mapView.alignInGrid(position.x, position.y));
    unitImage.setCompleteListenerRemove();
};

HomefixIntroAnimation.HERO_UNIT = {
    code: "chloepetit",
    stage: 0
};

HomefixIntroAnimation.HERO_POSITIONS = [
    { x: 23, y: 46 },
    { x: 30, y: 46 }
];
HomefixIntroAnimation.TAXI_POSITIONS = [
    { x: 21, y: 36 },
    { x: 21, y: 47 },
    { x: 21, y: 60 }
];

HomefixIntroAnimation.NAME = "base_homefix";